import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/SessionManagementService';
import { SignInRepository } from '../repositories/SignInRepository';

export class SetEmailUseCase {
    private signInRepository: SignInRepository;
    // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    constructor(private email: string) {
        this.signInRepository = diContainer.get(serviceNames.signInRepository);
    }

    public execute = async () => {
        await this.signInRepository.ensureFormStore();
        this.signInRepository.setEmail(this.email);
    };
}
